import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { mq } from '@helpers/breakpoints';
import Colors from '@theme/colors';

const FormLabelStyle = () => css`
  color: ${Colors.neutral75};
  font-size: 16px;
  display: block;
  margin-bottom: 10px;
  margin: 30px 10px 10px 0px;
  span {
    ${mq({
      fontSize: ['75%', '75%', '57%', '75%'],
    })}
  }
`;

const FormLabel = styled.label`
  ${FormLabelStyle}
`;

export { FormLabel };
